import { useEffect, useRef } from 'react';

import { onWsReconnect, sendWsMessage } from './useRealtimeNotifications';

export function useRealtimeSubscription(topics: string[]): void {
  const prevTopicsRef = useRef<string[]>([]);

  useEffect(() => {
    const prevTopics = prevTopicsRef.current;
    const toSubscribe = topics.filter((t) => !prevTopics.includes(t));
    const toUnsubscribe = prevTopics.filter((t) => !topics.includes(t));

    if (toSubscribe.length > 0) {
      sendWsMessage({ action: 'subscribe', topics: toSubscribe });
    }
    if (toUnsubscribe.length > 0) {
      sendWsMessage({ action: 'unsubscribe', topics: toUnsubscribe });
    }

    prevTopicsRef.current = topics;

    return () => {
      if (topics.length > 0) {
        sendWsMessage({ action: 'unsubscribe', topics });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topics.join(',')]);

  useEffect(() => {
    return onWsReconnect(() => {
      if (topics.length > 0) {
        sendWsMessage({ action: 'subscribe', topics });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topics.join(',')]);
}
